import { render, staticRenderFns } from "./TagDefinitionsList.vue?vue&type=template&id=0a0cc3be&scoped=true&"
import script from "./TagDefinitionsList.vue?vue&type=script&lang=js&"
export * from "./TagDefinitionsList.vue?vue&type=script&lang=js&"
import style0 from "./TagDefinitionsList.vue?vue&type=style&index=0&id=0a0cc3be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0cc3be",
  null
  
)

export default component.exports